// extracted by mini-css-extract-plugin
export default {"root":"mLO4sYd5","remaining":"H9rLc_1A","remainingOnly":"pp2TJXtO"};